import React from 'react';
import { withRouter } from 'react-router-dom';
import { shouldRefreshForServiceWorkerUpdate } from '../../serviceWorker';

const ServiceWorkerRefresh = React.memo((props) => {
  React.useEffect(() => {
    if (shouldRefreshForServiceWorkerUpdate()) window.location.reload();
  }, [props.location]);

  return null;
});

ServiceWorkerRefresh.propTypes = {};

ServiceWorkerRefresh.defaultProps = {};

ServiceWorkerRefresh.displayName = 'ServiceWorkerRefresh';

export default withRouter(ServiceWorkerRefresh);
